import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
export const ErrorState = ({ title }) => (<Card>
        <CardHeader>
            <CardTitle className="text-base">{title}</CardTitle>
        </CardHeader>
        <CardContent>
            <p className="text-sm text-muted-foreground">Failed to load A/B testing data.</p>
        </CardContent>
    </Card>);
ErrorState.displayName = 'ErrorState';
